// zustandVisualUnitSlice.ts
import { StateCreator } from 'zustand';
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit';
import { FoundationsEnums } from '../../enum';
import { IVuSettings, ChartSettings } from './visualUnitStateSlice';
import { VisualUnitApiDTO_VisualUnit_Extended } from '../../Interfaces/VisualUnit/VisualUnitApiDTO_VisualUnit';

export interface zustand_VisualUnitSlice {
  vuState: VisualUnitApiDTO_VisualUnit_Extended | null;

  setupVU: (vu: VisualUnitApiDTO_VisualUnit_Extended) => void;
  updateViewerType: (chartType: FoundationsEnums.VisualUnitViewerType) => void;
  updateChartSetting: (chartSettings: ChartSettings) => void;
  updateTableSetting: (tableSettings: IVuSettings) => void;
  updateChartSwitchSettings: (chartSwitchSettings: any) => void; ////Nooooooooooooo
  updateVUName: (newName: string) => void;
  updateChartFilters: (filters: any[]) => void //////////Nooooooooooooooooooo
  updateRefreshInterval: (refreshInterval: number) => void
}

export const createZustandVisualUnitSlice: StateCreator<zustand_VisualUnitSlice> = (set, get) => {
    const updateVUField = <K extends keyof VisualUnitApiDTO_VisualUnit_Extended>(key: K, value: VisualUnitApiDTO_VisualUnit_Extended[K]) => {
      set((state) =>
        state.vuState ? { vuState: { ...state.vuState, [key]: value } } : state
      );
    };

    return {
      vuState: null,

      setupVU: (vu) => {
        const state = get();
        // if (state.vuState !== null) {
        //   throw new Error('VU has already been set. setupVU can only be called once.');
        // }
        set({ vuState: vu });
      },

      updateChartSetting: (settings) => updateVUField('ChartSettings', settings),

      updateTableSetting: (settings) => updateVUField('TableSettings', settings),

      updateViewerType: (chartType) => updateVUField('ViewerType', chartType),

      updateChartSwitchSettings: (chartSwitchSettings: any) => updateVUField('ChartSwitch', chartSwitchSettings),

      updateVUName: (newName: string) => updateVUField('Name', newName),

      updateChartFilters: (filters: any[]) => updateVUField('ChartFilter', filters),

      updateRefreshInterval: (refreshInterval: number) => updateVUField('RefreshInterval', refreshInterval)
    };
  };